import { ComponentProps } from "react"
import { useFormikContext } from "formik"
import TagsFilter from "components/timenotes/filters/tags-filter"

interface TagsFilterFieldProps extends ComponentProps<typeof TagsFilter> {
  name: string
}

// TODO: fix styles passing as NOT WORKING ON TAGS FILTER LEVEL YET
const DEFAULT_STYLE = {}

const TagsFilterField = (props: TagsFilterFieldProps) => {
  const {
    name,
    ...teamFilterProps
  } = props

  const formik = useFormikContext<any>()

  return (
    <TagsFilter
      values={formik.values[name]}
      onChange={(values) => formik.setFieldValue(name, values)}

      style={{
        ...DEFAULT_STYLE,
        ...props.style,
      }}

      addNoTagOption={true}
      {...teamFilterProps}
    />
  )
}

export default TagsFilterField